module.exports = __webpack_public_path__ + "static/media/browser 1.2b3d2f68.svg";